import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Stack,
  Typography,
  TextField,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router";
import PlayStoreLogo from "../../assets/img/google-play-badge.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TopBanner from "../../assets/img/top_banner.jpeg";
import Bookmark from "../../assets/img/bookmark.png";
import { Footer } from "./footer";
import { useMediaQuery } from "@mui/material";
import "./landingPage.css";
import TurnedInNotIcon from "@mui/icons-material/TurnedInNot";
// import { Header } from "./header";
import { RestaurantPage } from "./restaurantPage";
import { HeaderLandingPage } from "./header";
import { routePath } from "../../constants/routePath";
import { CompassCalibration, Description } from "@mui/icons-material";

// logo image start
// services images start
import salon from "../../assets/img/services/Salon.jpg";
import mensParlour from "../../assets/img/services/SalonMale.jpg";
import beautyParlour from "../../assets/img/services/Beauty.jpg";
import unisex from "../../assets/img/services/unisex.jpeg";
import wellness from "../../assets/img/services/Wellness.jpg";
import spa from "../../assets/img/services/Spa.jpg";
import massage from "../../assets/img/services/Massage.jpg";
import tattoo from "../../assets/img/services/Tatoo.jpg";
import mehendi from "../../assets/img/services/Mehendi.jpg";
import skinCare from "../../assets/img/services/SkinCare.jpg";
import PanchKarma from "../../assets/img/services/Panchkarma.jpg";
import MakeUpHairStyle from "../../assets/img/services/Makeup.jpg";
// services images end

// social media icons start
import instagram from "../../assets/img/social/instagram.png";
import facebook from "../../assets/img/social/facebook.png";
import linkedIn from "../../assets/img/social/linkedin.png";
import Youtube from "../../assets/img/social/youtube.png";

// social media icons end

import businessOne from "../../assets/img/banner-bottom.jpeg";
import businessTwo from "../../assets/img/portrait_black.jpeg";
import { useEffect, useState } from "react";
import { cityName, cityNameCll } from "./landingPageApi";
import LocationModal from "./locationModal";
import { useDispatch, useSelector } from "react-redux";
import { setNavBarInputFields } from "../../app/store/reducer";
import { NavBar } from "../../common/landingPage/navbar";

import AvailabiltyIcon from "../../assets/img/whatIsElegantPrime/availabilityIconHome.png";
import UrgencyIcon from "../../assets/img/whatIsElegantPrime/urgencyIconHome.png";
import LocationIcon from "../../assets/img/whatIsElegantPrime/locationIconHome2.png";
import emergencyIcon from "../../assets/img/whatIsElegantPrime/emergencySituationsHome.png";
import comparisonIcon from "../../assets/img/whatIsElegantPrime/comparisonsIconHome.png";
import ratingsIcon from "../../assets/img/whatIsElegantPrime/ratingsIconHome.png";
import offersIcon from "../../assets/img/whatIsElegantPrime/offersIconHome.png";
import contactIcon from "../../assets/img/whatIsElegantPrime/contactIconHome.png";
import rareIcon from "../../assets/img/whatIsElegantPrime/rareProducts.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import BussinessApplication from "../../assets/img/whatIsElegantPrime/businessApplication.png";
import financialManagementIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/financialManagementIcon.png";
import bussinessGrowthIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/businessGrowthIcon.png";
import contactnoAddressIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/contactnoAddressIcon.png";
import customerDetailsIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/customerDetailsIcon.png";
import displayOffersIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/displayOfferIcomn.png";
import employeePayrollIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/employeePayrollIcon.png";
import inventoryManagementIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/inventoryManagementicon.png";
import markettingEffectivenessIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/markettingEffectivenessIcon.png";
import rateCardIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/rateCardIcon.png";
import shareMessagesIcon from "../../assets/img/whatIsElegantPrime/bussinessApplications/shareMessagesicon.png";
import assistanceImage from "../../assets/img/whatIsElegantPrime/assistanceImage.png";
import SEO from "../../common/SEO";

function WhatIsElegant() {
  const navigate = useNavigate();
  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields
  );
  const dispatch = useDispatch();
  const whyElegantArr = [
    {
      img: AvailabiltyIcon,
      title: "Availability",
      description:
        "Parlours can get fully booked during peak times. A quick search helps you secure your preferred slot",
    },
    {
      img: UrgencyIcon,
      title: "Urgency",
      description:
        "If you have an upcoming event, a quick search helps you find a parlour that fits your schedule.",
    },
    {
      img: LocationIcon,
      title: "Location",
      description:
        "While traveling, Elegant Prime helps you find nearby parlours with GPS directions based on your location.",
    },
    {
      img: emergencyIcon,
      title: "Emergency Situations",
      description:
        "For sudden beauty needs, a quick search helps you find a parlour for immediate care.",
    },
    {
      img: comparisonIcon,
      title: "Comparison",
      description:
        "Searching quickly allows you to compare different parlours based on their services, reviews, and prices to make an informed decision.",
    },
    {
      img: ratingsIcon,
      title: "Rating & Feedback",
      description:
        "You can check credibility of Parlour through feedback and rating registered on application.",
    },
    {
      img: offersIcon,
      title: "Offers",
      description:
        "Application will display To customer if any offer has given by parlour.",
    },
    {
      img: contactIcon,
      title: "Contact Number",
      description:
        "The app provides contact numbers for direct calls to confirm slot availability",
    },
    {
      img: rareIcon,
      title: "Rare available Products",
      description:
        "Find parlours that have your favorite or rare products not available in stores or pharmacies.",
    },
  ];
  const whyParlourArr = [
    {
      title: "Personal Grooming",
      description:
        "Beauty salons provide essential services like haircuts, hair styling, manicures, pedicures, facials, and waxing, helping individuals maintain their personal grooming standards.",
    },
    {
      title: "Self-Confidence",
      description:
        "Looking good often translates to feeling good. Beauty salons can boost self-confidence by helping individuals achieve the appearance they desire, which can positively impact their social and professional interactions.",
    },
    {
      title: "Special Occasions",
      description:
        "Beauty salons are often visited before special occasions such as weddings, parties, and job interviews. Clients seek professional styling and makeup services to ensure they look their best for these important events.",
    },
    {
      title: "Expertise and Advice",
      description:
        "Many beauty treatments offer relaxation and pampering experiences, providing clients with a break from their daily routines and stresses. Services like massages, facials, and spa treatments can promote relaxation and mental well-being.",
    },
    {
      title: "Relaxation and Pampering",
      description:
        "Many beauty treatments offer relaxation and pampering experiences, providing clients with a break from their daily routines and stresses. Services like massages, facials, and spa treatments can promote relaxation and mental well-being.",
    },
    {
      title: "Community and Socialization",
      description:
        "Beauty salons serve as social hubs where clients can interact with each other and form connections. They provide a space for conversation and camaraderie, fostering a sense of community.",
    },
    {
      title: "Skill Enhancement",
      description:
        "Beauty salons offer training and skill enhancement opportunities for aspiring beauty professionals. They serve as platforms for learning and development within the beauty industry.",
    },
  ];
  const servicesArr = [
    {
      title: "Salon",
      image: salon,
    },
    {
      title: "Men's Parlour",
      image: mensParlour,
    },
    {
      title: "Beauty Parlour",
      image: beautyParlour,
    },
    {
      title: "Unisex Parlour",
      image: unisex,
    },
    {
      title: "Wellness Center",
      image: wellness,
    },
    {
      title: "Spa",
      image: spa,
    },
    {
      title: "Massage Center",
      image: massage,
    },
    {
      title: "Menandi Artist",
      image: mehendi,
    },
    {
      title: "Tattoo Art Studio",
      image: tattoo,
    },
    {
      title: "Skincare",
      image: skinCare,
    },
    {
      title: "Panchkarm",
      image: PanchKarma,
    },
    {
      title: "Makeup & Hairstyle Artist",
      image: MakeUpHairStyle,
    },
  ];
  const businessOpsArr = [
    {
      img: financialManagementIcon,
      title: "Financial Management",
      description:
        "Tracking revenue, expenses, and profits helps in maintaining financial stability. It allows you to identify areas of high expenditure or low revenue and make necessary adjustments to improve profitability.",
    },
    {
      img: customerDetailsIcon,
      title: "Customer Details and History",
      description:
        "Keeping track of customer visits, preferences, and feedback helps in understanding customer behaviour and improving services to meet their needs better. This can lead to increased customer satisfaction and give them discount and offers.",
    },
    {
      img: inventoryManagementIcon,
      title: "Inventory Management",
      description:
        "Monitoring inventory levels and tracking usage helps in preventing stockouts or overstock situations. It ensures that you have the right products available for your customers when they need them, thereby maximizing sales opportunities.",
    },
    {
      img: employeePayrollIcon,
      title: "Employee Payroll",
      description:
        "Tracking employee schedules, productivity, and customer interactions helps in evaluating employee performance & Payroll. It enables you to identify top performers, provide necessary training or support to underperforming staff, and ensure optimal staffing levels to meet customer demand.",
    },
    {
      img: markettingEffectivenessIcon,
      title: "Marketing Effectiveness",
      description:
        "Monitoring the performance of marketing campaigns and promotions helps in assessing their effectiveness in attracting customers and driving sales. It allows you to allocate resources more efficiently to strategies that yield the highest returns.",
    },
    {
      img: bussinessGrowthIcon,
      title: "Business Growth",
      description:
        "By analysing key performance indicators (KPIs) and trends over time, tracking can help in identifying opportunities for growth and expansion. It enables you to make informed decisions about scaling your business operations.",
    },
    {
      img: displayOffersIcon,
      title: "Display offers",
      description:
        "Display offers on Elegant prime portal to show customers, It will help promotion of services to attract customers to visit shop.",
    },
    {
      img: shareMessagesIcon,
      title: "Share Messages",
      description:
        "Every parlour/salon wish to send discount and offer, festival wishes messages to customers, Elegant prime provide you to draft and send messages.",
    },
    {
      img: contactnoAddressIcon,
      title: "Contact Number and Address",
      description:
        "Parlour or salon Contact number and Address with Geographical location will get display on Elegant portal.",
    },
    {
      img: rateCardIcon,
      title: "Rate Card",
      description:
        "Every customer need rate card of beauty services before visit parlour, Elegant parlour showing these details on mobile app to customers.",
    },
  ];

  const [cityName, asignCityName] = useState("");
  const [locationModel, setLocationModal] = useState(false);
  const [currentLocation, setCurrentLocation] = useState("");
  useEffect(() => {
    cityNameCll((data) => {
      asignCityName(data?.city);
      setCurrentLocation(data?.city);
      dispatch(setNavBarInputFields({ location: data?.city }));
    });
  }, []);
  useEffect(() => {
    setLocationModal(false);
  }, [navBarInputFields.location]);
  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/whatIsElegantprime"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          textAlign: "center",
          fontWeight: 600,
          py: "8px",
          fontSize: "14px",
          fontFamily: "'Montserrat', sans-serif",
          cursor: "pointer",
        }}
        onClick={() => {
          navigate(routePath.LANDINGPAGE);
        }}
      >
        About Elegant Prime
      </Box>
      <Box container pt={4}>
        {/* <Header/> */}
        {/* <HeaderLandingPage /> */}
        {/* <LocationModal searchBarValue={cityName} currentLocation={currentLocation} open={locationModel} setOpen={setLocationModal}/>
      <NavBar navBarInputFields={navBarInputFields} setLocationModal={()=>{
        setLocationModal((prev)=>{
          return !prev
        })
      }}  /> */}

        {/* hero section start*/}

        <Box sx={{ fontFamily: "'Montserrat', sans-serif" }}>
          <Grid container spacing={2} px={{ sm: 5, xs: 0 }}>
            <Grid
              item
              md={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  paddingLeft: { sm: "100px", xs: "50px" },
                  paddingRight: "70px",
                  mb: { lg: 0, xs: 5 },
                  textAlign: { lg: "start", xs: "center" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "18px", sm: "35px", md: "40px" },

                    color: "primary.main",
                  }}
                  fontWeight={"700"}
                  mb={3}
                  lineHeight={"1"}
                  color={"#212529"}
                >
                  Search desired parlour/ salon services near by.
                </Typography>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: { xs: "12px", sm: "14px", md: "16px" },

                    fontWeight: 500,
                  }}
                  mb={5}
                >
                  Elegant Prime will help you to search list of parlours and
                  salons with contact Number, address, geographical location,
                  service rate card, offers, rating and feedback registered on
                  Elegant prime.
                </Typography>
                <Stack
                  sx={{
                    flexDirection: { lg: "row", xs: "column" },
                    alignItems: "center",
                  }}
                >
                  <a
                    class="me-lg-3 mb-4 mb-lg-0"
                    href="https://play.google.com/store/apps/details?id=com.mybills.elegantprime"
                    target="_blank"
                  >
                    <Box
                      height={"3rem"}
                      component={"img"}
                      src={PlayStoreLogo}
                      alt="playstorelogo"
                    />
                  </a>
                </Stack>
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box
                sx={{ borderRadius: "10px" }}
                width={"100%"}
                component={"img"}
                src={TopBanner}
                alt="playstorelogo"
              />
            </Grid>
          </Grid>
        </Box>
        {/* hero section end */}

        {/* What is Elegant Prime start */}
        <Box
          sx={{
            py: "5rem",
            background: "linear-gradient(180deg, #FFFFFF 0%, #D6D6FF 100%)",
          }}
        >
          <Box textAlign={"center"} mb={5}>
            <Typography
              fontWeight={"700"}
              lineHeight={"1.2"}
              sx={{
                fontSize: { xs: "18px", sm: "35px", md: "40px" },

                color: "primary.main",
              }}
            >
              What is Elegant Prime?
            </Typography>
            <Typography
              sx={{
                color: "primary.main",
                fontSize: { xs: "12px", sm: "14px", md: "16px" },

                fontWeight: 500,
              }}
            >
              Searching quickly for a beauty parlour/salon can be important for
              several reasons
            </Typography>
          </Box>

          <Grid
            container
            spacing={{ xs: 1, sm: 2 }}
            sx={{
              px: { sm: "20px", xs: "0px" },
              pl: { sm: "40px", xs: "20px" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            {whyElegantArr.map((item, index) => (
              <Grid
                key={index}
                item
                md={3}
                mb={{ sm: 2, xs: 1 }}
                sx={{ paddingX: "20px" }}
              >
                <Card
                  gap={"1"}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: { sm: "30vh", xs: "20vh" },
                    padding: "10px 20px",
                    backgroundColor: "#fff",
                    boxShadow: " 0px 4px 8.4px 2px #00000040",
                  }}
                >
                  {/* <TurnedInNotIcon
                    sx={{ color: "#9f1ae2", fontSize: "75px" }}
                  /> */}
                  <Box
                    sx={{ borderRadius: "10px" }}
                    width={{ sm: "76px", xs: "50px" }}
                    height={"auto"}
                    component={"img"}
                    src={item?.img}
                    alt="playstorelogo"
                  />
                  <Typography
                    className="kanit"
                    fontSize={{ xs: "16px", sm: "18px", md: "22px" }}
                    fontWeight={"600"}
                    textAlign={"center"}
                    // color={"#212529"}
                    color={"#01008B"}
                    margin={"5px 0px"}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    className="mulish"
                    fontSize={{ xs: "12px", sm: "13px", md: "14px" }}
                    fontWeight={"500"}
                    // color={"#6c757d "}
                    color={"#01008B"}
                    textAlign={"center"}
                  >
                    {item.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
        {/* What is Elegant Prime end */}

        {/* query start */}
        {/* <Box class="cta">
          <div class="cta-content">
            <Container sx={{ paddingLeft: "77px !important" }}>
              <Typography
                class="fontNewsreader querytitle"
                sx={{ fontSize: "48px", margin: "0px !important" }}
              >
                Please call Us In case of Any Query <br />
                or information
                <a href="tel:7721049949">772109949</a>
              </Typography>

              <Link
                href="https://play.google.com/store/apps/details?id=com.mybills.elegantprime"
                target="_blank"
              >
                <Button
                  className="mulish"
                  variant="outlined"
                  sx={{
                    px: "1.5rem",
                    py: "1rem",
                    borderRadius: "3rem",
                    borderColor: "#212529",
                    color: "#212529",
                    "&:hover": {
                      backgroundColor: "#212529",
                      borderColor: "#212529",
                      color: "#fff",
                    },
                  }}
                >
                  Download for free
                </Button>
              </Link>
            </Container>
          </div>
        </Box> */}
        {/* query end */}

        {/* why parlour start */}
        {/* <Box sx={{ py: "5rem", backgroundColor: "#fff" }}>
          <Container sx={{ px: 5 }}>
            <Box textAlign={"center"}>
              <Typography
                className="fontNewsreader"
                sx={{
                  fontSize: { xs: "2rem", sm: "3.5rem" },
                }}
                fontWeight={"600"}
                lineHeight={"1.2"}
                mb={5}
              >
                Why Everyone need parlours?
              </Typography>
            </Box>

            <Grid
              container
              sx={{ px: { sm: "60px", xs: "0px" } }}
              justifyContent={"center"}
              padding={"0px !important"}
            >
              {whyParlourArr.map((item, index) => (
                <Grid
                  key={index}
                  item
                  md={3}
                  justifyContent={"center"}
                  px={"24px"}
                  mb={5}
                >
                  <Stack alignItems={"center"} justifyItems={"center"} gap={1}>
                    <Box
                      sx={{ borderRadius: "10px" }}
                      width={"37px"}
                      height={"40px"}
                      component={"img"}
                      src={Bookmark}
                      alt="playstorelogo"
                    />
                    <Typography
                      className="kanit"
                      fontSize={"22px"}
                      fontWeight={"600"}
                      textAlign={"center"}
                      color={"#212529"}
                      margin={"5px 0px"}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      className="mulish"
                      fontSize={"14px"}
                      fontWeight={"400"}
                      color={"#6c757d "}
                      textAlign={"center"}
                    >
                      {item.description}
                    </Typography>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box> */}
        {/* why parlour  end */}

        {/* services start */}
        <Box sx={{ py: "5rem" }}>
          <Box textAlign={"center"}>
            <Typography
              sx={{
                fontSize: { xs: "18px", sm: "35px", md: "40px" },

                color: "primary.main",
              }}
              fontWeight={"700"}
              lineHeight={"1.2"}
              mb={5}
            >
              Explore Services on Elegant Prime
            </Typography>
          </Box>
          <Box pb={5} sx={{}}>
            <Grid container>
              <Grid item xs={12} sx={{ paddingX: "20px" }}>
                <Box sx={{ width: "100%", position: "relative" }}>
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    // slidesPerView={5.5}
                    loop={true}
                    autoplay={{ delay: 2000 }}
                    // onInit={(swiper) => {
                    //   swiper.params.navigation.nextEl = categoryRef.current;
                    //   swiper.navigation.init();
                    //   swiper.navigation.update();
                    // }}
                    breakpoints={{
                      1440: { slidesPerView: 5.5 },
                      1024: { slidesPerView: 5 },
                      768: { slidesPerView: 3 },
                      425: { slidesPerView: 1.3 },
                      375: { slidesPerView: 1.2 },
                      320: { slidesPerView: 1.2 },
                    }}
                  >
                    {servicesArr?.map((item) => (
                      <SwiperSlide>
                        <Card
                          sx={{
                            padding: "0",
                            boxShadow: "0px 4px 14.7px 5px #00000040",
                            borderRadius: "8px",
                          }}
                        >
                          <CardContent sx={{ padding: "0px !important" }}>
                            <img
                              src={item?.image}
                              alt="image"
                              style={{ width: "auto", height: "173px" }}
                            />
                            <Typography
                              sx={{
                                textAlign: "center",
                                color: "primary.main",
                                paddingY: "10px",
                                fontWeight: 600,
                              }}
                            >
                              {item?.title}
                            </Typography>
                          </CardContent>
                        </Card>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/* services end */}

        {/* Busiess Operation start */}
        <Box pt={{ sm: 5, xs: 2 }} pb={3} sx={{ backgroundColor: "#E7E7FF" }}>
          <Grid container px={{ sm: 5, xs: 1 }}>
            <Grid
              item
              xs={5}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                component={"img"}
                src={BussinessApplication}
                sx={{ width: "100%" }}
              ></Box>
            </Grid>
            {/* <Grid item xs={1}></Grid> */}
            <Grid
              item
              xs={7}
              sx={{ alignContent: "center", paddingLeft: "50px" }}
            >
              <Box>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: { xs: "18px", sm: "35pxpx", md: "40px" },

                    fontWeight: 700,
                  }}
                >
                  Elegant Prime is a Business Operation Application for
                  Parlours/Salons
                </Typography>
                <Typography
                  component={"p"}
                  mt={3}
                  sx={{
                    color: "primary.main",
                    fontWeight: 500,
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  }}
                >
                  Tracking parlour business operations is crucial for several
                  reasons
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ px: { sm: "60px", xs: "0px" } }}>
            <Grid
              container
              alignItems={"center"}
              spacing={2}
              sx={{ flexDirection: { md: "row", xs: "column-reverse" } }}
            >
              <Grid item md={12}>
                <Grid container>
                  {businessOpsArr.map((item, index) => (
                    <Grid key={index} item md={6} px={2} mb={5}>
                      <Card
                        sx={{
                          padding: "10px 25px",
                          height: "100%",
                          boxShadow: " 0px 4px 13.3px 0px #00000040",
                        }}
                      >
                        <Box
                          sx={{ borderRadius: "10px" }}
                          width={{ sm: "73px", xs: "54px" }}
                          height={"auto"}
                          component={"img"}
                          src={item?.img}
                          alt="playstorelogo"
                        />
                        <Typography
                          sx={{
                            fontSize: { xs: "16px", sm: "18px", md: "20px" },

                            color: "primary.main",
                            fontWeight: 700,
                            mb: 1,
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "14px" },

                            color: "primary.main",
                            fontWeight: 500,
                          }}
                        >
                          {item.description}
                        </Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/* Busiess Operation end */}

        <Box>
          <Grid container>
            <Grid item xs={1}></Grid>
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: { xs: "18px", sm: "28px", md: "36px" },

                    fontWeight: 700,
                  }}
                >
                  For assistance or enquiries, kindly call:
                </Typography>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: { xs: "18px", sm: "35px", md: "48px" },

                    fontWeight: 700,
                  }}
                >
                  7721049949
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={5}>
              <Box component={"img"} src={assistanceImage} width={"100%"}></Box>
            </Grid>
          </Grid>
        </Box>

        {/* social media section start */}
        <Box
          sx={{
            background:
              "linear-gradient(93.11deg, #7A79FF 13.11%, #01008B 84.65%)",
            // width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            padding: "40px 0",
            textAlign: "center",
          }}
        >
          <Typography
            className=""
            fontSize={{ xs: "16px", sm: "18px", md: "22px" }}
            sx={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600 }}
            color={"#fff"}
          >
            Follow us on social media
          </Typography>
          <Stack direction="row" spacing={2}>
            <Box
              component="a"
              href="https://www.instagram.com/salontech_elegant?igsh=NGJpd3c1dHQzNGIy"
              target="_blank"
            >
              <Box
                component="img"
                src={instagram}
                alt="instagram"
                sx={{
                  width: { sm: "48px", xs: "40px" },
                  height: { sm: "40px", xs: "35px" },
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box
              component="a"
              href="https://www.facebook.com/share/pvA1uawwosLT6exX/?mibextid=qi2Omg"
              target="_blank"
            >
              <Box
                component="img"
                src={facebook}
                alt="Facebook"
                sx={{
                  width: { sm: "48px", xs: "40px" },
                  height: { sm: "40px", xs: "35px" },
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box
              component="a"
              href="https://www.linkedin.com/company/elegant-prime/about/"
              target="_blank"
            >
              <Box
                component="img"
                src={linkedIn}
                alt="linkedIn"
                sx={{
                  width: { sm: "48px", xs: "40px" },
                  height: { sm: "40px", xs: "35px" },
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box
              component="a"
              href="https://www.youtube.com/@Elegantprime"
              target="_blank"
            >
              <Box
                component="img"
                src={Youtube}
                alt="youtube"
                sx={{
                  width: { sm: "48px", xs: "40px" },
                  height: { sm: "40px", xs: "35px" },
                  objectFit: "contain",
                }}
              />
            </Box>
          </Stack>
        </Box>
        {/* social media section end */}
        {/* copyright section start */}
        <Box
          sx={{
            height: "146px",
            backgroundColor: "#212529",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <Typography className="kanit" fontSize={"14px"} color={"#ffffff"}>
            © Powered by{" "}
            <Box
              component="a"
              href="https://www.posiviewtech.com"
              sx={{
                // textDecoration: "none",
                textDecorationLine: "underline",
                textDecorationThickness: "0.5px",
                color: "#ffffff",
                cursor: "pointer",
              }}
            >
              Posiview Application Technologies Pvt. Ltd.
            </Box>{" "}
            2024. All Rights Reserved.
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            component="ul"
            sx={{ padding: 0, margin: 0, listStyle: "none" }}
          >
            <Box component="li">
              <Typography
                sx={{
                  textDecoration: "none",
                  color: "#ffffff",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
                onClick={() => navigate(routePath.PRIVACYPOLICY)}
              >
                Privacy
              </Typography>
            </Box>
            <Box
              component="li"
              sx={{ position: "relative", paddingLeft: "16px" }}
            >
              <Typography
                sx={{
                  textDecoration: "none",
                  color: "#ffffff",
                  fontSize: "14px",
                  cursor: "pointer",
                  "&::before": {
                    content: '"•"',
                    color: "#ffffff80",
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "12px",
                  },
                }}
                onClick={() => navigate(routePath.TERMSOFSERVICE)}
              >
                Terms and conditions
              </Typography>
            </Box>
          </Stack>
        </Box>
        {/* copyright section end */}
        {/* <Footer /> */}

        {/* copyright section end */}
        {/* <Footer /> */}
      </Box>
    </>
  );
}

export default WhatIsElegant;
